export const sharesChangeTypes = [
  'c:484:c1',
  'c:484:c2',
  'c:484:c3',
  'c:2205'
];
